var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(!_vm.$vuetify.breakpoint.smAndDown)?_c('v-card',[_c('v-system-bar',[_vm._v("Pendente Rechnungen")]),_c('InvoiceTable',{attrs:{"items":_vm.itemsFiltered,"page":"InvoicePending"}})],1):[_c('InvoiceCards',{attrs:{"items":_vm.itemsFiltered,"page":"InvoicePending"}})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }